import { FormConfig } from '@workwave-tidal/core/form'
import { useMemo } from 'react'

import { Footer } from './Footer'
import { AssignmentsField } from './components/AssignmentsField'
import { form } from './formState'
import { useFormRecurrence } from './hooks/useFormRecurrence'
import { useOnSubmit } from './hooks/useOnSubmit'
import { useTexts } from './hooks/useTexts'
import type { DriverAssignmentFormState } from './typings'

interface Props {
  driverAssignment: uui.domain.client.rm.DriverAssignmentsWithId
  initialFormData: DriverAssignmentFormState
}

export function SingleEdit(props: Props) {
  const { driverAssignment, initialFormData } = props

  const recurrence = useFormRecurrence(driverAssignment.id)
  const texts = useTexts()
  const { submitting, onSubmit } = useOnSubmit(recurrence)

  const config = useMemo<FormConfig<DriverAssignmentFormState>>(
    () => ({
      id: 'driver-assignment-form',
      initialValues: initialFormData,
    }),
    [initialFormData],
  )

  return (
    <form.Form
      title={texts.headerTitle(recurrence)}
      subtitle={texts.headerDescription(recurrence)}
      footer={<Footer recurrence={recurrence} />}
      onSubmit={onSubmit}
      config={config}
      rightBorder
      requireTransaction
      stopEditingOnUnmount
      applyPendingFitMapOnMount
      width={484}
    >
      <AssignmentsField
        submitting={submitting}
        initialDriverAssignments={driverAssignment.assignments}
      />
    </form.Form>
  )
}
